
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import type { GetStaticPaths, GetStaticProps } from 'next';
import MusicLanding, { type MusicLandingProps, } from '@/components/music-landing/MusicLanding';
import { MUSIC_SUBPAGES } from '@/components/music-landing/pages';
import { getMusicPageProps } from '@/components/music-landing/server';
export default function MusicSubpage(props: MusicLandingProps) {
    return <MusicLanding {...props}/>;
}
const getStaticProps: GetStaticProps<MusicLandingProps> = async ({ params, locale, }) => {
    const props = getMusicPageProps(String(params?.slug ?? ''), locale);
    if (!props || props.page.id === 'main')
        return { notFound: true };
    return { props };
};
// Every locale the site has: each page lists all of them as hreflang
// alternates, so a locale left out here would be a broken link (vi was).
export const getStaticPaths: GetStaticPaths = async ({ locales }) => ({
    paths: MUSIC_SUBPAGES.flatMap((page) => (locales ?? ['en']).map((locale) => ({
        params: { slug: page.id },
        locale,
    }))),
    fallback: false,
});

    async function __Next_Translate__getStaticProps__1a13a29a166__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/ai-music-generator/[slug]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a13a29a166__ as getStaticProps }
  